import { createLandlordLeadDto } from '@/lib/leads/leads';

import { InquiryLandlordForm } from '../../../landlords/inquiry/_components/InquiryLandlordForm';
import { useLeadCreation } from '../useLeadCreation';

export function LandlordForm() {
  const { isLoading, handleFormSubmitted } = useLeadCreation();

  return (
    <InquiryLandlordForm
      isLoading={isLoading}
      onSubmit={(form) => handleFormSubmitted(createLandlordLeadDto(form))}
    />
  );
}
